export const HEADER_TABS_LABELS = {
  pickup: 'Retirada',
  dropoff: 'Devolução',
};
